import React from 'react'
import {Chip} from '@mui/material'
import {SEMANTIC, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface StatusPillProps {
  label: string
  color?: 'success' | 'warning' | 'error' | 'info' | 'default'
  withDot?: boolean
}

const COLOR_MAP = {
  success: {backgroundColor: SEMANTIC.success.light, color: SEMANTIC.success.dark, borderColor: SEMANTIC.success.border},
  warning: {backgroundColor: SEMANTIC.warning.light, color: SEMANTIC.warning.dark, borderColor: SEMANTIC.warning.border},
  error:   {backgroundColor: SEMANTIC.error.light,   color: SEMANTIC.error.dark,   borderColor: SEMANTIC.error.border},
  info:    {backgroundColor: SEMANTIC.info.light,     color: SEMANTIC.info.dark,    borderColor: SEMANTIC.info.border},
  default: {backgroundColor: NEUTRAL_SCALE[100], color: NEUTRAL_SCALE[700], borderColor: NEUTRAL_SCALE[200]},
} as const

export default function StatusPill({label, color = 'default', withDot = true}: StatusPillProps) {
  const styles = COLOR_MAP[color]
  const dotColor = COLOR_MAP[color].color

  return (
    <Chip
      label={withDot ? `● ${label}` : label}
      size="small"
      sx={{
        borderRadius: 9999,
        backgroundColor: styles.backgroundColor,
        color: dotColor,
        borderColor: styles.borderColor,
        border: '1px solid',
        fontWeight: 500,
        fontSize: 12,
        height: 24,
      }}
    />
  )
}
